import Image from "next/image";
import Icon from "../../public/images/icons/loading.gif";

const LoaderIcon = ({ ...rest }) => {
	return <Image src={Icon} alt="loading..." {...rest} />;
};

export default LoaderIcon;